import type {
  AssistantContentDescriptor,
  PlanAssistantAsk,
  PlanAssistantConversationContext,
} from '@/contexts/planAssistant.types';

export function isOperationsPlanAssistantContext(
  value: object,
): value is PlanAssistantConversationContext {
  const candidate = value as Partial<PlanAssistantConversationContext> & {
    contextVersion?: unknown;
  };
  return (
    candidate.contextVersion === 3 &&
    (candidate.planReferenceKind === 'saved-plan' ||
      candidate.planReferenceKind === 'generated-plan' ||
      candidate.planReferenceKind === 'simulation-recommended' ||
      candidate.planReferenceKind === 'simulation-pukkala-aaf') &&
    typeof candidate.propertyId === 'string' &&
    typeof candidate.planId === 'string' &&
    typeof candidate.planRevision === 'string'
  );
}

/**
 * Adapts route context into the explicit content contract consumed by the
 * generic dock. Route-specific recognition stays on this boundary.
 */
export function assistantContentForContext(
  context: object,
  planAssistantAsk?: PlanAssistantAsk,
  onContextExpired?: () => void,
): AssistantContentDescriptor {
  if (planAssistantAsk && isOperationsPlanAssistantContext(context)) {
    return {
      kind: 'plan-conversation',
      context,
      ask: planAssistantAsk,
      onContextExpired,
    };
  }
  return { kind: 'placeholder' };
}
